module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.0.2.0.box.252.676.1922.2338.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 3",
      "src": "data/content-0003.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.5.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.880.356.736.413.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.0.box.980.356.538.158.q.50"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.6.0.0"
    }
  }), _vm._v("Respectfully ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _vm._v("dedicated ")]), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _vm._v("to ")]), _c('i', [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v("the ")]), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _vm._v("memory ")]), _c('i', [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("of ")])]), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.1.box.880.712.296.57.q.50"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _vm._v("Zebulon Baird Vance")])]), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.2.box.1197.704.419.63.q.60"
    }
  }, [_c('i', [_vm._v("Congressman, Soldier, Governor")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.6.1.0.box.956.914.574.656.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.2.0.box.304.1785.1885.474.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.6.2.0.box.304.1785.1885.421.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("North ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carolina ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("we ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("had ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("great ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("men, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("any ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whom ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("honor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("State, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whom ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("our ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("people ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("been ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("still ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("justly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("proud ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of; ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("no ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("disparagement ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("those ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("say ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Zebulon ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Baird ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Vance ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mitchell ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("our ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("great ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("men, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("affections ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("people ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("he ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("towered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("above ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("As ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ages ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("come ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("able ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mar ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grandeur ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("greatness ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mitchell, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("so ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("they ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("able ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("efface ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hearts ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("minds ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("people ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("name ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("memory ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("their ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("beloved ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Vance. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "right"
    },
    attrs: {
      "id": "para.6.2.1.box.1558.2223.625.36.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _vm._v("Senator Thomas J. Jarvis")]), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.5.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.5.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.6.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.7.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.7.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.8.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.2.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.3.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.4.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.5.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.5.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0e18892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 54
// module chunks = 0